import React, { useState } from 'react'
import { CiGlobe } from "react-icons/ci";
import { FaSave } from "react-icons/fa";



function Domain() {
    const [DomainName, setDomainName] = useState('www.omni.anbums.co.in')
    return (
        <>
            <div>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1  '>
                    <h1 className='text-[#000] font-semibold text-[14px] dark:text-[#fff]'>Domain</h1>
                </div>
                <div className='w-[100%] mt-1'>
                    <h1 className=' font-semibold text-[12px] dark:text-[#fff] text-[#121519]'>Domain Name</h1>
                    <div className='border-[1px] border-[#cfcdcd w-[100%] rounded-lg pl-2 mt-2 flex items-center justify-between'>
                        <div className='flex items-center gap-1 text-[12px] text-[#535252] font-semibold dark:text-[#fff] '>
                            <CiGlobe />
                            <input type="text"
                                className='outline-none dark:bg-[#121519] '
                                value={DomainName}
                                onChange={(e) => { setDomainName(e.target.value) }}
                            />

                        </div>
                        <button className='border-[1px] border-[#3f7fca] text-[#3f7fca] hover:bg-[#3f7fca] hover:text-[#fff] flex items-center text-[12px] p-2 font-semibold rounded-lg gap-1'><FaSave />
                            Save</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Domain
